
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./use-slate-with-extensions.cjs.production.min.js')
} else {
  module.exports = require('./use-slate-with-extensions.cjs.development.js')
}
